import React, { useCallback, useEffect, useState } from 'react';
import { locationConstant } from '../../constants/constant';
import useLocationStore from '../../store/locatonStore';
import { translate } from '../../i18n';
import { DateSelector } from '../../components';
import Accordion from '../../components/common/Accordian';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import operationAPI from '../../api/operationApi';
import useDateStore from '../../store/selectedDateStore';
import {
  IPassengerManifestDTO,
  IWeatherDetail,
} from '../../type/passengerManifest';
import { IAddPaxOnFlight } from '../../type/addNotOnFlight';
import { toast } from 'react-toastify';
import { BallTriangle } from 'react-loader-spinner';
import {
  encodeDateForUrl,
  formatTimeToHHMM,
  getAdjustedDate,
} from '../../utils/dateUtils';
import passengerManifestApi from '../../api/passengerManifest';
import CalendarHeader from '../../components/common/Header/CalenderHeader';
import useBgColorStore from '../../store/bgColor';
import Card from '../../components/common/Header/Card';
import CalenderIcon from '../../assets/CalenderIcon';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import { showOrReplaceToast } from '../../utils/utility';

const PassengerManifestMobile = () => {
  const { selectedDateFromStore, setSelectedDateFromStore } = useDateStore();
  const [selectedDate, setSelectedDate] = useState<Date>(
    selectedDateFromStore || getAdjustedDate(),
  );
  const selectedLocation = useLocationStore((state) => state.selectedLocation);

  const handleToDateChange = (date: Date | null) => {
    if (date) {
      setSelectedDate(date);
      setSelectedDateFromStore(date);
    }
  };

  
    useEffect(() => {
      setSelectedDate(selectedDateFromStore);
    }, [selectedDateFromStore]);
  const [passengerManifest, setPassengerManifest] =
    useState<IPassengerManifestDTO>();
  const [loading, setLoading] = useState(true);
  const [weatherDetails, setWeatherDetails] = useState<IWeatherDetail>();

  const fetchPassengerManifest = useCallback(async () => {
    setLoading(true);
    try {
      const encodedDate = encodeDateForUrl(selectedDate);
      const response = await passengerManifestApi.getPassengerManifest(
        encodedDate,
        selectedLocation.OwnerId,
      );
      setLoading(false);
      setPassengerManifest(response?.data);
      setWeatherDetails(response?.data?.weatherDetails);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, [selectedDate]);
  useEffect(() => {
    fetchPassengerManifest();
  }, [fetchPassengerManifest, selectedDate]);

  const addPaxNotInFlight = async (data: IAddPaxOnFlight) => {
    try {
      const response = await passengerManifestApi.addNotOnFlight(data);
      showOrReplaceToast('operations', translate(response?.data), 'success');
    } catch (error) {
      console.log(error);
      toast.warn(translate('operation.commonError'));
    }
  };
  const { bgColor, updateBgColor } = useBgColorStore();
  const windData = [
    { altitude: '1000', value: weatherDetails?.wind1 ?? '-' },
    { altitude: '2000', value: weatherDetails?.wind2 ?? '-' },
    { altitude: '3000', value: weatherDetails?.wind3 ?? '-' },
    { altitude: '5000', value: weatherDetails?.wind4 ?? '-' },
  ];
  const Metar = [
    { altitude: 'Temperature', value: weatherDetails?.temperature1 ?? '-' },
    { altitude: 'Pressure', value: weatherDetails?.pressure ?? 'N/A' },
    { altitude: 'SWSD', value: weatherDetails?.swsd ?? 'N/A' },
  ];
  const location = [
    { altitude: 'Location', value: 'PD' },
    { altitude: 'Time', value: '12:30PM' },
  ];

  return (
    <div className="h-max bg-background">
      <div className="mt-2  bg-backgroundColor-white">
        <CalendarHeader />
      </div>
      {loading ? (
        <div className="flex justify-center items-center h-80">
          <BallTriangle
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="loading"
            visible={true}
          />
        </div>
      ) : (
        <>
          <div className="bg-background">
            <div className="flex items-start pl-4 pr-4 pt-4 mb-2  bg-sidebar-darkThemeColor">
              <span className="font-semibold text-base text-textColor  bg-sidebar-darkThemeColor ">
                {translate('passengerManifest.PassengerManifest')}
              </span>
            </div>
            <div
              className={`flex justify-between items-center  bg-backgroundColor-white gap-1 pl-4 pr-4 pt-4 rounded`}
            >
              <div className={`flex flex-col`}>
                <label className="text-sm text-start mb-1 text-textColorGray">
                  {translate('common.location')}
                </label>
                <div className={`relative group w-fit `}>
                  {/* Truncated Text */}
                  <div
                    className={`flex items-center space-x-1  h-[44px] p-2 rounded cursor-pointer 
      max-w-[150px] overflow-hidden whitespace-nowrap text-ellipsis truncate  ${bgColor}  text-text-primary border-customBorder-border`}
                  >
                    {(selectedLocation.OwnerId == locationConstant.ownerId
                      ? translate('passengerManifest.portDuglasLocation')
                      : translate('passengerManifest.goldCostLocation')
                    ).slice(0, 19) + '...'}
                  </div>

                  {/* Tooltip */}
                  <span
                    className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-max px-2 py-1 bg-gray-800 text-button-white text-sm rounded 
      opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                  >
                    {selectedLocation.OwnerId == locationConstant.ownerId
                      ? translate('passengerManifest.portDuglasLocation')
                      : translate('passengerManifest.goldCostLocation')}
                  </span>
                </div>
              </div>

              <div className="flex flex-col">
                <label className="text-sm text-start mb-1 text-textColorGray">
                  {translate('common.date')}
                </label>
                <div
                  className={`flex items-center space-x-1  h-[44px] p-2 rounded ${bgColor}  text-text-primary border-customBorder-border`}
                >
                  <DateSelector
                    onDateChange={handleToDateChange}
                    initialDate={selectedDate}
                    showArrows={true}
                  />
                </div>
              </div>
            </div>
            <div
              className={`h-screen ${
                passengerManifest?.bookingDetails?.length === 0
                  ? bgColor
                  : 'bg-backgroundColor-white'
              }`}
            >
              {passengerManifest?.bookingDetails?.length === 0 ? (
                <div
                  className={`mt-4 flex items-center justify-center h-[50%] text-textColorGray text-center `}
                >
                  {translate('passengerManifest.dataNotAvailable')}
                </div>
              ) : (
                <div className={`space-y-4 bg-background`}>
                  {passengerManifest?.bookingDetails?.map((res) => {
                    return (
                      <>
                        <div className="mt-5 ">
                          <Accordion
                            title={`Balloon VH -${res.balloonName}`}
                            bgColor={bgColor}
                            iconOpen={
                              <div>
                                <div className="block dark:hidden">
                                  <AccordianDownIcon />
                                </div>
                                <div className="hidden dark:block">
                                  <AccordianDownIconDark />
                                </div>
                              </div>
                            }
                            iconClose={
                              <div>
                                <div className="block dark:hidden">
                                  <AccordianUpIcon />
                                </div>
                                <div className="hidden dark:block">
                                  <AccordianUpIconDark />
                                </div>
                              </div>
                            }
                          >
                            <div className="flex w-full justify-between mb-4">
                              <div className="flex flex-col pl-2">
                                <span className="text-textColorGray flex text-start">
                                  {translate('passengerManifest.Pilot')}
                                </span>
                                <span className="text-textColor">
                                  {res.pilotName}
                                </span>
                              </div>

                              <div className="flex flex-col pr-2 text-start">
                                <span className="text-textColorGray">
                                  {translate('passengerManifest.flightTime')}
                                </span>
                                <span className="text-textColor">
                                  {
                                    res?.flightTime
                                  }
                                </span>
                              </div>
                            </div>

                            <div className="pb-2 space-y-4">
                              <Card
                                title={`${translate('passengerManifest.winds')}`}
                                data={windData}
                                labelKey="altitude"
                                valueKey="value"
                                className="grid-cols-4 gap-4"
                              />

                              <Card
                                title={`${translate('passengerManifest.meter')}`}
                                data={Metar}
                                labelKey="altitude"
                                valueKey="value"
                                className="grid-cols-3 gap-4"
                              />

                              <Card
                                title={`${translate('passengerManifest.launchSite')}`}
                                labelKey="altitude"
                                valueKey="value"
                                className="grid-cols-2 gap-4 mt-2"
                                data={[
                                  {
                                    altitude: 'Location',
                                    value:
                                      res?.launchSite ??
                                      translate(
                                        'operation.flightDetails.blankSpace',
                                      ),
                                  },
                                  {
                                    altitude: 'Time',
                                    value:
                                    
                                      formatTimeToHHMM(
                                        res?.balloonTakeOfTime,
                                      ) ??
                                      translate(
                                        'operation.flightDetails.timeBlankSpace',
                                      ),
                                  },
                                ]}
                              />

                              <Card
                                title={`${translate('passengerManifest.landingSite')}`}
                                labelKey="altitude"
                                valueKey="value"
                                className="grid-cols-2 gap-2 mt-2"
                                data={[
                                  {
                                    altitude: 'Location',
                                    value:
                                      res?.landSite ??
                                      translate(
                                        'operation.flightDetails.blankSpace',
                                      ),
                                  },
                                  {
                                    altitude: 'Time',
                                    value:
                                      formatTimeToHHMM(res?.balloonLandTime) ??
                                      translate(
                                        'operation.flightDetails.timeBlankSpace',
                                      ),
                                  },
                                ]}
                              />
                            </div>
                            {res.bookings.map((bookings) => {
                              return (
                                <>
                                  <Accordion
                                    title={`${bookings.paxName}`}
                                    bgColor="bg-backgroundColor-white"
                                  >
                                    <div className="p-2">
                                      <div className="grid grid-cols-2 gap-4 text-textColorGray text-sm">
                                        <div className="text-start">
                                          <p className="font-medium text-textColorGray">
                                            {translate(
                                              'passengerManifest.haRef',
                                            )}
                                          </p>
                                          <p className="text-textColorGray">
                                            {bookings.bookingId}
                                          </p>
                                        </div>
                                        <div className="text-start">
                                          <p className="font-medium text-textColorGray">
                                            {translate(
                                              'passengerManifest.country',
                                            )}
                                          </p>
                                          <p className="text-textColorGray">
                                            {bookings.country}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="mt-4 text-start">
                                        <p className="font-medium text-textColorGray text-sm ">
                                          {translate(
                                            'passengerManifest.meetingPoint',
                                          )}
                                        </p>
                                        <p className="text-textColorGray font-semibold">
                                          {bookings.pickup}
                                        </p>
                                      </div>

                                      <div className="mt-4 flex items-center space-x-2">
                                        <input
                                          type="checkbox"
                                          className="w-4 h-4 border-gray-400 rounded"
                                          defaultChecked={
                                            bookings?.notOnFlight || false
                                          }
                                          onChange={(e) => {
                                            console.log(
                                              e.target.checked,
                                              'checked',
                                            );
                                            const data: IAddPaxOnFlight = {
                                              bookingProductNameId:
                                                bookings.bookingProductNameId,
                                              bookingProductChildId:
                                                bookings.bookingProductChildId,
                                              operationBalloonFlightId:
                                                res?.operationBalloonFlightId,
                                              isPaxDeleted: e.target.checked,
                                            };
                                            addPaxNotInFlight(data);
                                          }}
                                        />
                                        <label className="text-textColorGray text-sm">
                                          {translate(
                                            'passengerManifest.notOnThisFlight',
                                          )}
                                        </label>
                                      </div>
                                    </div>
                                  </Accordion>
                                </>
                              );
                            })}
                          </Accordion>
                        </div>
                      </>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PassengerManifestMobile;
